import { render, staticRenderFns } from "./PendingOrganizationDetails.vue?vue&type=template&id=34252f0b&scoped=true&"
import script from "./PendingOrganizationDetails.vue?vue&type=script&lang=js&"
export * from "./PendingOrganizationDetails.vue?vue&type=script&lang=js&"
import style0 from "./PendingOrganizationDetails.vue?vue&type=style&index=0&id=34252f0b&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34252f0b",
  null
  
)

export default component.exports